module.exports = {
  replaceTplImagePath(str) {
    let content = str;
    if (content) {
      content = content.replace(
        /"http:\/\/img.gohappy\.com\.tw\/tpl/gi,
        '"https://img.shopping.friday.tw/tpl'
      );
      content = content.replace(
        /("\/tpl)/gi,
        '"https://img.shopping.friday.tw/tpl'
      );
      return content;
    }
    return '';
  },
  replaceWidthAndHeight(str) {
    let content = str;
    if (content) {
      content = content.replace(/height:\s?\d+px;?/gi, '');
      content = content.replace(/(width):\s?\d+px;?/gi, 'width:100%;');
      content = content.replace(/(height="(\d+)")/gi, '');
      content = content.replace(/(width="(\d+)")/gi, 'width="100%"');
      return content;
    }
    return '';
  },
  replaceContentTagStyle(str) {
    let content = str;
    if (content) {
      content = content.replace(/(style="([\d\w;:-]+)")/gi, '');
      return content;
    }
    return '';
  },
  getCookie(cname) {
    var mycookie = document.cookie.split('; ');
    for (var i = 0; i < mycookie.length; i++) {
      var cookie1 = mycookie[i].split('=');
      if (cookie1[0] == cname) {
        return decodeURIComponent(cookie1[1]);
      }
    }
    return null;
  }
};
